/* eslint-disable @typescript-eslint/no-empty-function */
import React from 'react'
import KnowDisplayWithoutExperiment from 'components/feature/Know/view/Authenticated/KnowDisplayWithoutExperiment'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import { GetStaticPaths, GetStaticProps } from 'next'
import { parseLocale } from 'lib/constants/localization'

function Know() {
    return <KnowDisplayWithoutExperiment />
}

export default Know

export const getStaticProps: GetStaticProps = async (props) => ({
    props: {
        ...(await serverSideTranslations(parseLocale(props.locale).interfaceLanguageCode, ['common', 'knows'])),
    },
})
export const getStaticPaths: GetStaticPaths<{ uuid: string }> = async () => {
    return {
        paths: [],
        fallback: 'blocking',
    }
}
